export const SUPPORTED_EXTENSIONS_GROUPS = {
  audio: ['aac', 'flac', 'mp3', 'ogg', 'wav'],
  video: ['avi', 'mkv', 'mov', 'mp4', 'mpeg'],
  image: ['bmp', 'eps', 'gif', 'jpeg', 'jpg', 'png', 'psb', 'psd', 'tif', 'tiff'],
  document: ['csv', 'doc', 'docx', 'key', 'odp', 'ods', 'odt', 'pdf', 'ppt', 'pptx', 'rtf', 'txt', 'xls', 'xlsx'],
  design: ['ai', 'blend', 'fbx', 'fla', 'obj', 'skp', 'stp', 'step'],
};

export const supportedFileExtensions: string[] = Object.values(SUPPORTED_EXTENSIONS_GROUPS).flat();
